import awsInfo from '../../public/websocket';

export default {
  state: () => ({
    username: '',
    token: '',
    loggedIn: false,
    name: '',
    organisation: '',
    userType: '',
    navToggleState: false,
  }),
  mutations: {
    navToggle(state, payload) {
      state.navToggleState = payload;
    },
    setToken(state, token) {
      state.token = token;
    },
    setLoggedIn(state, loggedIn) {
      state.loggedIn = loggedIn;
    },
    setUserInfo(state, { name, organisation, userType }) {
      state.name = name;
      state.organisation = organisation;
      state.userType = userType;
    },
  },
  actions: {
    navToggle({ commit }, payload) {
      commit('navToggle', payload);
    },
    getMyInfo() {
      awsInfo.getMyInfo();
    },
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getUserInfo(state) {
      return {
        name: state.name,
        organisation: state.organisation,
      };
    },
  },

};
